import type { FC, PropsWithChildren } from 'react'

import { Translation } from './i18n/Translation'

import './LoadingError.styles.scss'

export const LoadingError: FC<PropsWithChildren> = ({ children }) => (
  <div className="loading-error">
    {children || (
      <Translation id="We've encountered an error while loading data. Please refresh." />
    )}
  </div>
)
